import { css } from 'styled-components';
import token from 'styled-token';
import { dropdownChevronMixin } from '../dropdownChevronMixin';
import { spaceMixin } from '../spaceMixin';
import { InputMixin } from './InputMixin';

/** @class SelectMixin */
/** @method */
export var SelectMixin = function SelectMixin(props) {
  return token('Select.chevronWidth', function (chevronWidth) {
    return css(["", " ", " appearance:none;padding-right:", "px;&:not(:disabled){cursor:pointer;}&::-ms-expand{display:none;}"], InputMixin(props), !props.readOnly ? dropdownChevronMixin(props) : null, spaceMixin('xs', function (space) {
      return space.value + chevronWidth;
    })(props));
  })(props);
};